import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchFinancials, updatePage } from '../../../redux/financials'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'
import Financials from './component'

class FinancialsContainer extends Component {
  componentDidMount () {
    if (!this.props.financials[this.props.selectedRound]) {
      this.props.fetchFinancials(this.props.teamNumber, this.props.selectedRound)
    }
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.selectedRound !== this.props.selectedRound ||
      prevProps.roundNumber !== this.props.roundNumber ||
      prevProps.teamNumber !== this.props.teamNumber ||
      (!prevProps.isCurrentTab && this.props.isCurrentTab)
    ) {
      if (!this.props.financials[this.props.selectedRound]) {
        this.props.fetchFinancials(this.props.teamNumber, this.props.selectedRound)
      }
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  render () {
    if (this.props.isLoading) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    if (!this.props.financials[this.props.selectedRound]) {
      return <InlineError message={`No financials have been uploaded for round ${this.props.selectedRound}`} />
    }
    const financials = { ...this.props.financials[this.props.selectedRound] }
    financials.summary = financials.summary.filter(s => s.enabled)
    return (
      <Financials
        financials={financials}
        selectedRound={this.props.selectedRound}
        currentPage={this.props.currentPage}
        updatePage={this.props.updatePage}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'OurFinancials',
  currentPage: state.financials.currentPage,
  teamNumber: state.team.id,
  selectedRound: state.game.selectedRound,
  roundNumber: state.game.currentRound,
  isLoading: state.financials.isLoading,
  isLoaded: state.financials.isLoaded,
  error: state.financials.error,
  financials: state.financials.financials
})

export default connect(mapStateToProps, {
  fetchFinancials,
  updatePage
})(FinancialsContainer)
